import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {RoleService} from "../../services/role.service";
import {InvoicesService} from "../services/invoices.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {VoucherOrdersService} from "../services/voucherOrders.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../services/company.service";
import {ProductService} from "../services/product.service";
import {AnnualFeeDeductionService} from "../services/annual-fee-deduction.service";
import {MatTableGeneratorComponent} from "../../shared/mat-table-generator/mat-table-generator.component";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {AnnualFeeDeduction, Invoice} from "../../dto/invoice";
import {toDateString, toDateTimeStringNoSeconds} from "../../providers/app-date-adapter";
import {EmailSendStatus} from "../../dto/order-status";
import {AnnualFeeStatsModel} from "../../models/annual-fee-stats-model";
import {ContentRowField} from "../../shared/content-row/content-row.component";
import {PartnerWallet} from "../../dto/partnerWallet";

@Component({
  selector: 'app-annual-fee-deductions',
  templateUrl: './annual-fee-deductions.component.html',
  styleUrls: ['./annual-fee-deductions.component.css']
})
export class AnnualFeeDeductionsComponent implements OnInit {

  constructor(
      private route: ActivatedRoute,
      private router: Router,
      private roleService: RoleService,

      public annualFeeDeductionsService: AnnualFeeDeductionService,
      private productService: ProductService,) { }


  @ViewChild(MatTableGeneratorComponent, {static: true}) table: MatTableGeneratorComponent;

  ngOnInit(): void {
  }


  dataSource = new MultiCrudDataSource(this.annualFeeDeductionsService);
  columns = [

    {
      columnDef: 'date',
      header: 'Date',
      cell: row => `${toDateTimeStringNoSeconds(row.date) || ''}`
    },
    {columnDef: 'token', header: 'Card', cell: row => `${row.token}`},
    {columnDef: 'primaryToken', header: 'Primary', cell: row => `${row.primaryToken}`},

    {columnDef: 'amount', header: 'Amount', cell: row => `${row.amount}`},
    {columnDef: 'amountTaken', header: 'Amount Taken', cell: row => `${row.amountTaken}`},


  ] as ContentRowField<AnnualFeeDeduction>[];
  customActions: any[] = [];


  editEnabled() {
    return false;
  }

  deleteEnabled() {
    return false;
  }

  getRowClass = (item: AnnualFeeDeduction): string => '';

  getViewLink = (item: AnnualFeeDeduction): string => item.id.toString();

  getEditLink = (item: AnnualFeeDeduction): string => item.id.toString() + '/edit';

}
